import Vue from "vue";
/* eslint-disable */
/**
 * 描述：
 * 指令传值必须为 数组类型（Array）且 length 值大于0
 *
 * 实现方式通过获取指令所在节点 offsetTop 值作为滚动目标，用 window.scrollTo() 滚动至目标位置
 *
 * 同一个页面中锚点名称是唯一的
 */
export default {
  /**
   * 预加值
   */
  addValue: 0,
  /**
   * 锚点名称存储对象
   */
  anchorMap: {},
  install(addValue) {
      this.addValue = typeof addValue === 'number' ? addValue : 0 ;
      const that = this
      Vue.directive('anchor', {
          componentUpdated (el, binding, vnode, oldVnode) {
              // console.log('v-anchor');
              // console.log(el, binding, vnode);

              if(binding.value.lenth > 0) {
                new Error('请填写锚点名称')
                return
              }

              if(!that.anchorMap[window.location.pathname]) {
                that.anchorMap[window.location.pathname] = {}
              }

              binding.value.forEach(item => {
                if(!that.anchorMap[window.location.pathname][item]){
                  // console.dir(el);
                  // console.log(el.offsetTop);
                  // console.log(object);
                  that.anchorMap[window.location.pathname][item] = el.offsetTop
                } else {
                  // console.warn(`${item} 名称已存在`);
                }
              });


          }
      })
      Vue.prototype.$mAnchor = function (name) {
          // console.log(name);
          // console.log(that.anchorMap[window.location.pathname]);
          // console.log(that.anchorMap[window.location.pathname][name]);
          if(typeof that.anchorMap[window.location.pathname][name] === 'number') {
            // console.log('top');
            // console.log(that.addValue);
            let _top = that.anchorMap[window.location.pathname][name]
            // console.log('trget', _top + that.addValue);
            window.scrollTo(0, _top + that.addValue)
          } else {
            new Error('锚点不存在')
          }
      }
  }
}

